var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "tasks-page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskType),
      expression: "taskType"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "typ úkolu",
      "data-testid": "tasks-feed-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("mé úkoly")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("mnou zadané úkoly")])]), _vm._v(" "), (_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("nesplněné")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("nesplněné")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed",
      "data-testid": "tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed",
      "data-testid": "tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončené")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušené")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "tasks-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.tasks.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'tasks-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [_c('task-change-state', {
      attrs: {
        "actual-state": task.state,
        "task-id": task.id
      },
      on: {
        "update": _vm.getDoctorsDayTasks
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-left col-sm-2",
      attrs: {
        "data-testid": 'tasks-client-' + task.id
      }
    }, [(task.client !== null) ? [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: task.client.id
          }
        },
        "data-testid": 'tasks-client-link-' + task.id
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(task.client.full_name))]), _c('br'), (task.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(task.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(task.client.p_i_n))])])] : [_c('span', [_vm._v("- - -")])]], 2), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'tasks-kind-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.template !== null ? task.template.name : 'jiný') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-4",
      attrs: {
        "data-testid": 'tasks-text-' + task.id
      }
    }, [(_vm.editingTaskId === task.id) ? [_c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putTask(task)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingTask.text),
        expression: "editingTask.text"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "text",
        "data-testid": 'tasks-edit-input-' + task.id
      },
      domProps: {
        "value": (_vm.editingTask.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingTask.text = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'tasks-edit-save-' + task.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'tasks-edit-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.editTask(task.text, task.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" " + _vm._s(task.template !== null ? task.template.text + ' - ' : '') + _vm._s(task.text) + "\n                        ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2",
      attrs: {
        "data-testid": 'tasks-assignees-' + task.id
      }
    }, [_vm._l((task.assigned_medics), function(assigned_medic, index) {
      return [_vm._v("\n                            " + _vm._s(assigned_medic.fullname)), (index != task.assigned_medics.length - 1) ? [_vm._v(", ")] : _vm._e()]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'vytvořil/a: <b>' + task.created_by.fullname + '</b>' + (task.completed_by !== null ? '<br>splnil/a: <b>' + task.completed_by.fullname + '</b>' : ''),
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                            content: 'vytvořil/a: <b>' + task.created_by.fullname + '</b>' + (task.completed_by !== null ? '<br>splnil/a: <b>' + task.completed_by.fullname + '</b>': ''),\n                            placement: 'bottom-center',\n                            classes: ['info']}"
      }],
      staticClass: "fa fa-2x fa-info-circle text-info"
    })])])]
  })], 2)])]) : (_vm.tasksPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "tasks-empty"
    }
  }, [_vm._m(3)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Úkoly")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Druh")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-4"
  }, [_vm._v("Úkol")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Úkol pro")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný úkol)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3893951c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Task/components/Tasks.vue
// module id = 756
// module chunks = 0